export default __webpack_public_path__ + "static/media/check.9d0f793c.svg";